export enum Mode {
  DEFAULT,
  EDIT,
  CREATE,
  READONLY,
  DISABLED,
}

// TODO: move to constants folder and rename to Mode instead of IForm
